// extracted by mini-css-extract-plugin
module.exports = {"desktopOnly":"deviceVisibility-module__desktopOnly___3wX43","mobileOnly":"deviceVisibility-module__mobileOnly___2CUI7"};